import {
    DndContext,
    MouseSensor,
    TouchSensor,
    useSensor,
    useSensors
} from "@dnd-kit/core";
import {snapTopCursor} from "../../utils/common/snapTopCursor";
import {Grid} from "./Grid";
import {DragEvents, DragEventsType, DragItemType, GridType} from "../../types";
import Draggable from "./Draggable";
import styled from "styled-components";
import {DIMENSION_GRID} from "../../contants";
import {useSizeItem} from "../../provider/ResizeProvider";

const activationConstraint = {distance: 0};

interface Props {
    gridData: GridType;
    dragItems: DragItemType[];
    onDragEvent: (type: DragEventsType, over: string) => void;
    setDragItem: (item: DragItemType | null) => void;
}

const GAP_TOOLS_PANEL = 10;

const ToolsPanel = styled.div<{itemSize: number}>`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    height: ${({itemSize}) => itemSize}px;
    margin-top: 14px;
    width: 100%;
    gap: ${GAP_TOOLS_PANEL}px;
    align-items: center;
    justify-items: center;
    max-width: ${({itemSize}) => itemSize * DIMENSION_GRID}px;
    
     &:nth-child(1) {
         grid-column: 1 / span 1;
     }

     &:nth-child(2) {
         grid-column: 1 / span 1;
     }

     &:nth-child(3) {
         grid-column: 1 / span 1;
         justify-content: center;
     }
`;

const Content = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    ${window.innerHeight > window.innerWidth && `@media (min-width: 768px) {
        flex-grow: 1;
        justify-content: center;
        margin-top: -15%;
    }`};
`;

export const GameGrid = ({gridData, setDragItem, onDragEvent, dragItems}: Props) => {
    const {itemSize} = useSizeItem();
    const mouseSensor = useSensor(MouseSensor, { activationConstraint });
    const touchSensor = useSensor(TouchSensor, {activationConstraint});
    const sensors = useSensors(mouseSensor, touchSensor);

    return (
        <DndContext
            modifiers={[snapTopCursor]}
            onDragStart={(props) => {
                const dragItemId = props.active.id as string;

                const dragIndex = dragItems.findIndex(item => `${item.typeOfItem}___${item.id}` === dragItemId);

                if (dragIndex !== undefined) {
                    setDragItem(dragItems[dragIndex]);
                }
            }}
            onDragOver={(event) => {
                onDragEvent(DragEvents.OVER, (event.over?.id as string) || "")
            }}
            onDragEnd={({ over }) => {
                    over?.id && onDragEvent(DragEvents.END, over?.id as string);
                    setDragItem(null);
            }
            }
            sensors={sensors}
        >
            <Content>
                <Grid gridData={gridData} />
                <ToolsPanel itemSize={itemSize}>
                    {dragItems.map((item) => (
                        <Draggable
                            key={`${item.typeOfItem}___${item.id}`}
                            id={`${item.typeOfItem}___${item.id}`}
                            dragItem={item}
                        />
                    ))}
                </ToolsPanel>
            </Content>
        </DndContext>
    )
}
